import { Link } from "react-router-dom";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-brand-dark text-neutral-200 mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="font-serif text-4xl leading-tight text-white mb-4">Grüne Geldanlage.</div>
          <p className="text-neutral-400 max-w-md leading-relaxed">
            Redaktionelles Portal für nachhaltige Geldanlagen im deutschsprachigen Raum.
            Unabhängig, faktenbasiert – ohne Anlageberatung.
          </p>
        </div>

        <div className="md:col-span-2">
          <div className="text-xs uppercase tracking-[0.2em] text-brand-accent mb-4">Inhalt</div>
          <ul className="space-y-3">
            <li><Link to="/" className="hover:text-white text-neutral-300" data-testid="footer-home">Startseite</Link></li>
            <li><Link to="/blog" className="hover:text-white text-neutral-300" data-testid="footer-blog">Blog</Link></li>
            <li><Link to="/rechner" className="hover:text-white text-neutral-300" data-testid="footer-rechner">Rechner &amp; Tools</Link></li>
            <li><Link to="/nachhaltige-geldanlage-deutschland" className="hover:text-white text-neutral-300" data-testid="footer-marktreport">Marktreport</Link></li>
            <li><Link to="/ueber-uns" className="hover:text-white text-neutral-300" data-testid="footer-about">Über uns</Link></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <div className="text-xs uppercase tracking-[0.2em] text-brand-accent mb-4">Rechtliches</div>
          <ul className="space-y-3">
            <li><Link to="/impressum" className="hover:text-white text-neutral-300" data-testid="footer-impressum">Impressum</Link></li>
            <li><Link to="/datenschutz" className="hover:text-white text-neutral-300" data-testid="footer-datenschutz">Datenschutz</Link></li>
            <li><Link to="/cookie-richtlinien" className="hover:text-white text-neutral-300" data-testid="footer-cookies">Cookie-Richtlinien</Link></li>
            <li><Link to="/risikohinweis" className="hover:text-white text-neutral-300" data-testid="footer-risiko">Risikohinweis</Link></li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <div className="text-xs uppercase tracking-[0.2em] text-brand-accent mb-4">Disclaimer</div>
          <p className="text-sm text-neutral-400 leading-relaxed">
            Die Inhalte dieses Portals dienen ausschließlich der allgemeinen Information und
            stellen keine Anlageberatung, Kauf- oder Verkaufsempfehlung dar. Kapitalanlagen
            unterliegen Marktschwankungen und Verlustrisiken.
          </p>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-neutral-500">
          <div>© {year} Grüne Geldanlage. Alle Rechte vorbehalten.</div>
          <div>Redaktion Grüne Geldanlage · Deutschland</div>
        </div>
      </div>
    </footer>
  );
}
